import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../services/apiService';
import WGS84Service from '../../services/wgs84ProjectionService';
import { mapState } from 'vuex';
import get from 'lodash/get';
import MarkdownItVueLight from 'markdown-it-vue/dist/markdown-it-vue-light.umd.min.js';
export default {
  name: 'CoreFavdigitaltwin',
  components: {
    MarkdownItVueLight: MarkdownItVueLight
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    tileSizeSetting: {
      type: Number,
      required: true,
      default: 0
    }
  },
  data: function data() {
    return {
      twinDataStates: [],
      transparent: 'rgba(255, 255, 255, 0)',
      dtwin: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])), {}, {
    cardLink: function cardLink() {
      var id = get(this.dtwin, 'id');

      if (!id) {
        // return no link if no id is available
        return null;
      } // get type and fallback to digitalTwin if not available


      var type = get(this.dtwin, 'properties.type', 'digitalTwin');
      return type === 'virtualDevice' ? "/virtual-devices/".concat(id) : "/digitaltwin-mgmt/".concat(id, "?dashboard");
    },
    showMap: function showMap() {
      if (get(this.dtwin, 'coordinates.coordinates[1]')) {
        return this.hasValidCoordinate;
      }

      return false;
    },
    dsize: function dsize() {
      if (this.tileSizeSetting === 1) {
        return '-big';
      }

      return '';
    },
    headerBG: function headerBG() {
      var bigPicc = null;

      if (get(this.dtwin, 'data.twinImageId')) {
        bigPicc = "".concat(process.env.VUE_APP_API_HOST).concat(process.env.VUE_APP_API_PATH, "/upload/").concat(this.dtwin.data.twinImageId);
      }

      return bigPicc ? bigPicc : './img/dtwin-factory1.png';
    },
    dtwinCoordinates: function dtwinCoordinates() {
      return get(this.dtwin, 'coordinates.coordinates', [null, null]);
    },
    hasValidCoordinate: function hasValidCoordinate() {
      var coordinate = {
        lat: this.dtwinCoordinates[1],
        lon: this.dtwinCoordinates[0]
      };
      return WGS84Service.isValidWgs84(coordinate);
    }
  }),
  mounted: function mounted() {
    this.digitalTwinGetData();
  },
  methods: {
    digitalTwinGetData: function digitalTwinGetData() {
      var _this = this;

      ApiService.digitalTwinGet(this, this.item.objectId).then(function (data) {
        _this.dtwin = data;

        if (!data || !data.id) {
          _this.$emit('invalid');
        } else {
          _this.loadStates();
        }
      }).catch(function (error) {
        if (get(error, 'response.data.message') === 'DTWIN_NOT_RIGHT_TYPE') {
          _this.virtualDeviceGetData(_this, _this.item.objectId);
        }
      });
    },
    virtualDeviceGetData: function virtualDeviceGetData() {
      var _this2 = this;

      ApiService.virtualDeviceGet(this, this.item.objectId).then(function (data) {
        _this2.dtwin = data;

        if (!data || !data.id) {
          _this2.$emit('invalid');
        } else {
          _this2.loadStates();
        }
      }).catch(function () {
        // something happened, the twin does not exist any more, or user has no permission
        _this2.$emit('invalid');
      });
    },
    loadStates: function loadStates() {
      var _this3 = this;

      return ApiService.digitalTwinFetchStates(this, this.dtwin.id).then(function (twinDataStates) {
        _this3.twinDataStates = twinDataStates.map(function (state) {
          return Object.assign({}, state, {
            title: state.properties.title,
            unit: state.properties.unit,
            stateValue: state.value ? state.value.value : null,
            stateTime: state.value ? state.value.time : null
          });
        });
      }).catch(function (error) {
        console.error('Error reading twin states', error);
      });
    },
    pushToRouter: function pushToRouter(path) {
      var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      this.$router.push({
        path: path,
        query: {
          parent: selected ? selected.id : null,
          openTree: JSON.stringify(this.open)
        }
      });
    }
  }
};